import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IconComponent } from '../../elements/icon/icon.component';
import { Icons } from '../../../model/icon';
import { TokenStorageService } from '../../../services/token.storage.service';
import {LoginInfo} from '../../../model/login';
import {LoginService} from '../../../services/login.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, IconComponent],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {
  loginGroup: FormGroup;
  error: string = '';
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private tokenStorageService: TokenStorageService,
    private router: Router
  ) {
    this.loginGroup = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  login() {
    if (this.loginGroup.invalid) {
      this.error = 'Please enter username and password';
      return;
    }

    this.loading = true;
    this.error = '';

    const username = this.loginGroup.get('username')?.value;
    const password = this.loginGroup.get('password')?.value;

    this.loginService.login(username, password).subscribe({
      next: (loginInfo: LoginInfo) => {
        this.tokenStorageService.saveLoginInfo(loginInfo);
        this.loginService.update();
        this.loading = false;
        this.router.navigate(['/admin']);
      },
      error: (error: { status: number; error: { message: string; }; }) => {
        this.loading = false;
        if (error.status === 403) {
          this.error = 'Invalid username or password';
        } else {
          this.error = error.error?.message || 'Login failed. Please try again.';
        }
        console.error('Login error:', error);
      }
    });
  }

  protected readonly Icons = Icons;
}
